@if (process && executionSteps) {
  <div class="container-fluid" style="max-width: inherit;">
    @for (step of executionSteps; track step) {
      <div style="border: 1px solid var(--border-strong); border-radius: 4px; margin-bottom: 10px; padding: 10px;">
        <h1 style="font-size: 20px;">{{step.name}}</h1>
        @for (item of step.items; track item) {
          <div>
            @for (element of item.elements; track element) {
              <div>
                @if (element.type==='upload') {
                  <app-file-upload-element [fileupload]="element" [processId]="process.id"
                    (onUploadDone)="onStepFileUpload(element.key, step.key, $event)" [activeElements]="this.enabledReferences"
                    [uploadDisabled]="step.status==='DRAFT'"
                    >
                  </app-file-upload-element>
                }
                @if (element.type==='file-static') {
                  <app-file-upload-element [fileupload]="element" [activeElements]="this.enabledReferences"
                    [uploadDisabled]="step.status==='DRAFT'"
                    [processId]="process.id">
                  </app-file-upload-element>
                }
                @if (element.type==='file-template') {
                  <app-file-upload-element [fileupload]="element" [processId]="process.id" [uploadDisabled]="step.status==='DRAFT'"
                    [activeElements]="this.enabledReferences">
                  </app-file-upload-element>
                }
              </div>
            }
          </div>
        }
      </div>
    }
    @for (document of process.documents; track document) {
      <app-file-upload-element [documentSection]="true" [fileupload]="document"
        [processId]="process.id" (onUploadDone)="onFileUpload(uploadElement.key, $event)"
      (documentDeleted)="deleteFromProcess($event)"></app-file-upload-element>
    }
  </div>
}
@if (process) {
  <app-file-upload-element [documentSection]="true" [fileupload]="uploadElement" [processId]="process.id"
  (onUploadDone)="onFileUpload(uploadElement.key, $event)"></app-file-upload-element>
}